import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    segmentLabel: string;
    onCloseButtonClick?: () => void;
}

const ScoringDetailsTitle = (props: React.PropsWithChildren<Props>) => {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            borderBottom="1px solid rgba(232, 232, 232, 0.5)"
            p={1}
        >
            <Box>
                <Title>
                    {props.segmentLabel}
                    <Label> – Score Details</Label>
                </Title>
            </Box>
            <IconButton onClick={props.onCloseButtonClick}>
                <CloseButton />
            </IconButton>
        </Stack>
    );
};

const CloseButton = () => (
    <SvgIcon>
        <g opacity="0.4">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.1465 22.9282C18.2216 22.9282 23.1465 18.0034 23.1465 11.9282C23.1465 5.85309 18.2216 0.928223 12.1465 0.928223C6.07135 0.928223 1.14648 5.85309 1.14648 11.9282C1.14648 18.0034 6.07135 22.9282 12.1465 22.9282ZM15.3528 7.27732C15.7517 6.87843 16.3984 6.87843 16.7973 7.27732C17.1962 7.67621 17.1962 8.32294 16.7973 8.72184L13.591 11.9282L16.7973 15.1345C17.1962 15.5334 17.1962 16.1801 16.7973 16.579C16.3984 16.9779 15.7517 16.9779 15.3528 16.579L12.1465 13.3727L8.94014 16.579C8.54125 16.9779 7.89451 16.9779 7.49562 16.579C7.09673 16.1801 7.09673 15.5334 7.49562 15.1345L10.7019 11.9282L7.49562 8.72184C7.09673 8.32294 7.09673 7.67621 7.49562 7.27732C7.89451 6.87843 8.54125 6.87843 8.94014 7.27732L12.1465 10.4836L15.3528 7.27732Z"
                fill="black"
            />
        </g>
    </SvgIcon>
);

const Title = styled(Typography)`
    color: #1c1c1e;
    font-size: 15px;
    line-height: 24px;
`;

const Label = styled.span`
    color: #1c1c1e;
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
`;

export default ScoringDetailsTitle;
